(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sollos-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSollosHeroSlider = (section = document) => {
      section.querySelectorAll('[data-sollos-hero-slider]').forEach((slider) => {
        if (slider.dataset.sollosSliderReady === 'true') return;

        const slides = Array.from(slider.querySelectorAll('.sollos-editorial-home__hero-slide'));
        const captions = Array.from(slider.querySelectorAll('[data-sollos-slide-caption]'));
        const controls = Array.from(slider.querySelectorAll('[data-sollos-slide-control]'));
        const nextButtons = Array.from(slider.querySelectorAll('[data-sollos-slide-next]'));
        const previousButtons = Array.from(slider.querySelectorAll('[data-sollos-slide-previous]'));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        let timer;
        let startX = 0;
        let pointerDown = false;

        if (activeIndex < 0) activeIndex = 0;

        const setSlide = (index, shouldRestart = true) => {
          activeIndex = (index + slides.length) % slides.length;

          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });

          controls.forEach((control, controlIndex) => {
            const isActive = controlIndex === activeIndex;
            control.classList.toggle('is-active', isActive);
            control.setAttribute('aria-current', isActive ? 'true' : 'false');
          });

          captions.forEach((caption, captionIndex) => {
            caption.classList.toggle('is-active', captionIndex === activeIndex);
          });

          if (shouldRestart) restartTimer();
        };

        const nextSlide = () => setSlide(activeIndex + 1);
        const previousSlide = () => setSlide(activeIndex - 1);

        const stopTimer = () => {
          if (timer) window.clearInterval(timer);
          timer = undefined;
        };

        const startTimer = () => {
          if (reducedMotion || slides.length < 2) return;
          timer = window.setInterval(nextSlide, 6000);
        };

        const restartTimer = () => {
          stopTimer();
          startTimer();
        };

        controls.forEach((control) => {
          control.addEventListener('click', () => {
            const index = Number(control.dataset.sollosSlideControl);
            setSlide(index);
          });
        });

        nextButtons.forEach((button) => {
          button.addEventListener('click', nextSlide);
        });

        previousButtons.forEach((button) => {
          button.addEventListener('click', previousSlide);
        });

        slider.addEventListener('pointerdown', (event) => {
          pointerDown = true;
          startX = event.clientX;
        });

        slider.addEventListener('pointerup', (event) => {
          if (!pointerDown) return;
          pointerDown = false;

          const distance = event.clientX - startX;
          if (Math.abs(distance) < 42) return;

          if (distance < 0) {
            nextSlide();
          } else {
            previousSlide();
          }
        });

        slider.addEventListener('pointercancel', () => {
          pointerDown = false;
        });

        slider.dataset.sollosSliderReady = 'true';
        setSlide(activeIndex, false);
        startTimer();
      });
    };

    document.addEventListener('DOMContentLoaded', () => initSollosHeroSlider());
    document.addEventListener('shopify:section:load', (event) => initSollosHeroSlider(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
